/**
 * Configuration file for Raven, the JavaScript library for Sentry
 *
 * This file is where you define overrides for the default raven parameters.
 */

export default {

  /**
   * Sentry DSN
   */
  sentryDSN: 'https://b5c30dba35254c7da1da44ae4a986465@sentry.io/1408878',

  /**
   * Sentry environment to report as
   */
  environment: 'development',

  /**
   * Enable or disable reporting
   */

  enabled: false

};
